<!--Swapnil please assign the smartlabel carousel class via ngClass -->
<div class="smartlabel-carousel slideshow">
  <ion-grid fixed class="fixed ion-fixed">
    <ion-row justify-content-center class="justify-content-center ion-justify-content-center">
      <ion-col>
        <div class="preview">
          <ion-img [src]="getActiveImage()"></ion-img>
        </div>
      </ion-col>
    </ion-row>


    <div class="thumbnails">
      <ng-container *ngFor="let image of config.images; index as i;">

        <ion-thumbnail (click)=setActiveImage(i) [ngClass]="{'active': i === activeImageIndex}">
          <ion-img [src]="image.url"></ion-img>
        </ion-thumbnail>

      </ng-container>
    </div>



  </ion-grid>
</div>